import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
export function PricingTable() {
  return <section id="pricing" className="py-20 px-4" data-id="element-187">
      <div className="max-w-5xl mx-auto" data-id="element-188">
        <div className="text-center mb-12" data-id="element-189">
          <h2 className="text-4xl md:text-5xl font-black mb-4" data-id="element-190">
            ELEGÍ TU ULTRAPACK
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-191">
          {/* Plan 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-dark-card border border-dark-border rounded-3xl p-8 flex flex-col" data-id="element-192">
            <div className="text-2xl mb-4" data-id="element-193">📘</div>
            <h3 className="text-2xl font-bold mb-2" data-id="element-194">
              ULTRAPACK MANICURISTA PRO
            </h3>
            <p className="text-gray-400 mb-6 h-12" data-id="element-195">
              Ideal para quien quiere construir un negocio serio
            </p>

            <div className="mb-8" data-id="element-196">
              <div className="text-gray-500 line-through mb-1" data-id="element-197">
                Precio normal $51.000
              </div>
              <div className="text-5xl font-black text-white mb-2" data-id="element-198">
                $19.990{' '}
                <span className="text-xl text-gray-500 font-medium" data-id="element-199">ARS</span>
              </div>
            </div>

            <div className="space-y-4 mb-8 flex-grow" data-id="element-200">
              <div className="flex items-center space-x-3" data-id="element-201">
                <Check className="w-5 h-5 text-brand" data-id="element-202" />
                <span className="font-bold" data-id="element-203">6 Tomos del Sistema</span>
              </div>
              <div className="flex items-center space-x-3" data-id="element-204">
                <Check className="w-5 h-5 text-brand" data-id="element-205" />
                <span className="font-bold" data-id="element-206">6 Bonos Estratégicos</span>
              </div>
            </div>

            <a href="https://ultrapack.digital/cart/47712619593902:1" target="_blank" rel="noopener noreferrer" className="w-full block text-center bg-dark-border hover:bg-gray-700 text-white font-bold py-4 px-6 rounded-xl transition-colors" data-id="element-207">
              → QUIERO MI ULTRAPACK
            </a>
          </motion.div>

          {/* Plan 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-gradient-to-b from-dark-card to-dark border-2 border-brand rounded-3xl p-8 flex flex-col relative transform md:-translate-y-4 shadow-[0_0_40px_rgba(244,63,122,0.15)]" data-id="element-208">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand text-white px-4 py-1 rounded-full text-sm font-bold flex items-center space-x-1" data-id="element-209">
              <Star className="w-4 h-4 fill-white" data-id="element-210" />
              <span data-id="element-211">MÁS ELEGIDO</span>
            </div>

            <div className="text-2xl mb-4" data-id="element-212">🏆</div>
            <h3 className="text-2xl font-bold mb-2 text-brand" data-id="element-213">
              ULTRAPACK PRO + ACELERADOR ⭐
            </h3>
            <p className="text-gray-300 mb-6 h-12" data-id="element-214">
              Ideal para quien quiere resultados en 30 días con mapa día a día
            </p>

            <div className="mb-8" data-id="element-215">
              <div className="text-gray-500 line-through mb-1" data-id="element-216">
                Precio normal $69.000
              </div>
              <div className="text-5xl font-black text-white mb-2" data-id="element-217">
                $27.990{' '}
                <span className="text-xl text-gray-500 font-medium" data-id="element-218">ARS</span>
              </div>
            </div>

            <div className="space-y-4 mb-8 flex-grow" data-id="element-219">
              <div className="flex items-center space-x-3" data-id="element-220">
                <Check className="w-5 h-5 text-brand" data-id="element-221" />
                <span className="font-bold" data-id="element-222">6 Tomos del Sistema</span>
              </div>
              <div className="flex items-center space-x-3" data-id="element-223">
                <Check className="w-5 h-5 text-brand" data-id="element-224" />
                <span className="font-bold" data-id="element-225">6 Bonos Estratégicos</span>
              </div>
              <div className="flex items-start space-x-3 bg-brand/10 p-3 rounded-lg border border-brand/20" data-id="element-226">
                <Check className="w-5 h-5 text-brand mt-0.5" data-id="element-227" />
                <span className="font-bold text-brand" data-id="element-228">
                  Ruta Crítica 30 Días (Acelerador)
                </span>
              </div>
            </div>

            <a href="https://ultrapack.digital/cart/47718470353070:1" target="_blank" rel="noopener noreferrer" className="w-full block text-center bg-brand hover:bg-brand-dark text-white font-bold py-4 px-6 rounded-xl transition-all hover:scale-105 shadow-[0_0_20px_rgba(244,63,122,0.4)]" data-id="element-229">
              → QUIERO EL ULTRAPACK + ACELERADOR
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}